import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "amor_token";

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const absUrl = (url) =>
  url && url.startsWith("/api/") ? `${BACKEND_URL}${url}` : url;

export const api = {
  getProducts: (params) => client.get("/products", { params }).then((r) => r.data),
  getProduct: (slug) => client.get(`/products/${slug}`).then((r) => r.data),
  getSettings: () => client.get("/settings").then((r) => r.data),
  updateSettings: (s) => client.put("/settings", s).then((r) => r.data),
  login: (username, password) =>
    client.post("/admin/login", { username, password }).then((r) => r.data),
  verify: () => client.get("/admin/verify").then((r) => r.data),
  getStats: () => client.get("/admin/stats").then((r) => r.data),
  createProduct: (d) => client.post("/products", d).then((r) => r.data),
  updateProduct: (id, d) => client.put(`/products/${id}`, d).then((r) => r.data),
  deleteProduct: (id) => client.delete(`/products/${id}`).then((r) => r.data),
  reorderProducts: (ids) => client.post("/products/reorder", { ids }).then((r) => r.data),
  uploadImage: (dataUrl) =>
    client.post("/images", { dataUrl }).then((r) => r.data),
  subscribe: (email) => client.post("/subscribe", { email }).then((r) => r.data),
  getSubscribers: () => client.get("/subscribers").then((r) => r.data),
  deleteSubscriber: (id) => client.delete(`/subscribers/${id}`).then((r) => r.data),
};
